export const SET_USER_STAT = "SET_USER_STAT";
export const SET_PAYMENT_STAT = "SET_PAYMENT_STAT";
